/**
 * (配車スケジュール 新規登録/詳細) 配送先設定ボタンScript関数ファイル
 */

/* Import Modules */
import $ from "jquery";

/* Copy Script */
// [配送先に設定]ボタン 押下イベント
export const copyDeliveryDestinationFromCooperatingStore = () => {
    // 協力店.住所 → 配送先.住所
    $("#delivery_address").val(null);
    $("#delivery_address").val($("#cooperating_store_address").val());
    // 協力店.担当者名 → 配送先.受取人
    $("#recipient_name").val(null);
    $("#recipient_name").val($("#cooperating_responsible_name").val());
    // 協力店.連絡先 → 配送先.受取人連絡先
    $("#delivery_tel").val(null);
    $("#delivery_tel").val($("#cooperating_store_tel").val());
};

/**
 * グローバル関数を定義
 */
(window as any).copyDeliveryDestinationFromCooperatingStore = copyDeliveryDestinationFromCooperatingStore;
